/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStyles, makeStyles } from '@material-ui/core';

type Props = {
  backgroundColor?: string;
  margin?: string;
  borderRadius?: string;
  titleColor?: string;
  textTransform?: any;
  fontSize?: string;
  paddingContent?: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    gridContent: {
      display: 'flex',
      padding: (props: Props) => props.paddingContent,
      backgroundColor: (props: Props) => props.backgroundColor,
      margin: (props: Props) => props.margin,
      borderRadius: (props: Props) => props.borderRadius,
      textAlign: 'left',
      alignItems: 'center',
    },
    gridContentText: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    icon: {
      width: 15,
      height: 15,
    },
    title: {
      margin: '0 5px!important',
      color: (props: Props) => `${props.titleColor}!important`,
      fontWeight: '600!important' as any,
      fontSize: (props: Props) => `${props.fontSize}!important`,
      textTransform: (props: Props) => props.textTransform,
    },
    titleSecondary: {
      margin: '0 5px!important',
      color: '#008000!important',
      fontWeight: '600!important' as any,
      fontSize: (props: Props) => `${props.fontSize}!important`,
      textTransform: (props: Props) => props.textTransform,
      right: 12,
    },
  }),
);

export default useStyles;
